import { render, staticRenderFns } from "./ResidentRules.vue?vue&type=template&id=f8eb4e16&scoped=true"
import script from "./ResidentRules.vue?vue&type=script&lang=ts"
export * from "./ResidentRules.vue?vue&type=script&lang=ts"
import style0 from "./ResidentRules.vue?vue&type=style&index=0&id=f8eb4e16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8eb4e16",
  null
  
)

export default component.exports